import React from 'react'

interface AuthShellProps {
  title: string
  message?: string
  error?: string
}

/** Centered, branded card used by the SSO redirect and callback screens. */
export const AuthShell: React.FC<AuthShellProps> = ({ title, message, error }) => (
  <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[var(--bg-sidebar)] px-4">
    <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-primary-500/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-40 -right-24 h-[28rem] w-[28rem] rounded-full bg-indigo-500/20 blur-3xl" />

    <div className="relative w-full max-w-sm">
      <div className="mb-8 flex items-center justify-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-primary-500 to-indigo-500 shadow-lg shadow-primary-900/50">
          <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div>
          <p className="font-display text-xl font-bold leading-tight text-white">SprintBid</p>
          <p className="text-xs text-slate-400">AI-Powered Proposal Pipeline</p>
        </div>
      </div>

      <div className="rounded-2xl border border-white/10 bg-white p-7 shadow-pop">
        <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
        {!error && message && (
          <div className="mt-3 flex items-center gap-3 text-sm text-slate-600">
            <svg className="h-4 w-4 flex-shrink-0 animate-spin-slow text-primary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" d="M12 3a9 9 0 1 0 9 9" strokeOpacity={0.25} />
              <path strokeLinecap="round" d="M12 3a9 9 0 0 1 9 9" />
            </svg>
            <p>{message}</p>
          </div>
        )}
        {error && (
          <>
            <p className="mt-3 rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800" role="alert">
              {error}
            </p>
            <button
              type="button"
              onClick={() => window.location.assign('/login')}
              className="mt-4 h-10 w-full rounded-xl bg-primary-600 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primary-700"
            >
              Try again
            </button>
          </>
        )}
      </div>
      <p className="mt-6 text-center text-xs text-slate-500">Jaya Consulting Inc.</p>
    </div>
  </div>
)

export const PageLoader: React.FC<{ label?: string }> = ({ label = 'Loading page...' }) => (
  <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-sm text-slate-500">
    <svg className="h-6 w-6 animate-spin-slow text-primary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
      <path strokeLinecap="round" d="M12 3a9 9 0 1 0 9 9" strokeOpacity={0.25} />
      <path strokeLinecap="round" d="M12 3a9 9 0 0 1 9 9" />
    </svg>
    {label}
  </div>
)
